import * as React from "react";
import LinearProgress, {LinearProgressProps} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number; mean: number | undefined },
) {
    const percentage = props.mean ? (props.value / props.mean) * 100 : 0;
    const isOverLimit = percentage > 100;

    return (
        <Box sx={{width: "100%"}}>
            <Box sx={{display: "flex", alignItems: "flex-end", flexDirection: "column"}}>
                <Box sx={{minWidth: 100}}>
                    <Typography variant="body2" sx={{color: "text.secondary"}}>
                        {`${Math.round(props.value)}s ${props.mean ? `/ ${props.mean}s` : ""}`}
                    </Typography>
                </Box>
                <Box sx={{width: "100%"}}>
                    <LinearProgress
                        variant="determinate"
                        value={Math.min(percentage, 100)}
                        sx={{
                            "&.MuiLinearProgress-root": {
                                backgroundColor: "action.hover",
                            },
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: isOverLimit ? "error.main" : "primary.main",
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}
